
// Base.
import { Prop, Mixins } from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from './UsersMixin'

// Used Models.
import { User } from '@/models/user'
import UserService from '@/services/UserService'

// Used for notifications.
import { INotificationService } from '@/services/NotificationService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class EnableWifi extends Mixins(usersMixins) {
  @Prop() private user!: User
  @Prop() private wifi!: boolean
  @Prop() private readonly disabled!: boolean
  @Prop() private readonly onClose!: () => void

  // Used for notification.
  private $notificationService!: INotificationService
  private errorHandlerService: ErrorHandlerService = new ErrorHandlerService()

  private async save(user: User) {
    this.isPending = true
    const schoolId = user.etablissement_id
    try {
      if (!this.wifi) {
        await UserService.toggleWifi(
          user.ad_personne_id,
          user.identifiant,
          user.fonctions,
          schoolId,
          1,
        )
        this.updateWifi(true)
      } else {
        await UserService.toggleWifi(
          user.ad_personne_id,
          user.identifiant,
          user.fonctions,
          schoolId,
          0,
        )
        this.updateWifi(false)
      }
      this.$notificationService.success(
        this.$t('USER.WifiUpdateSucceed').toString() + user.identifiant,
      )
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    } finally {
      this.cancel()
      this.isPending = false
    }
    this.cancel()
    this.onClose()
    this.isPending = false
  }

  private updateWifi(value: boolean) {
    this.$emit('update:wifi', value)
  }
}
